<template>
  <div>
    <div class="vx-row mt-0">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">Current Outbound Reference</label>
        <vs-input
          class="w-full"
          v-model="oldReference"
          placeholder="Enter current outbound reference"
          @keyup.enter="searchPreview"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full" style="display:flex;align-items:flex-end;">
        <vs-button
          color="warning"
          class="btn mb-4 md:mb-0"
          @click="searchPreview"
          :disabled="oldReference == ''"
        >
          Search
        </vs-button>
      </div>
    </div>

    <div class="vx-row mt-6" v-if="showPreview" style="display:flex;align-items:stretch;">
      <div class="vx-col md:w-1/2 w-full" style="display:flex;">
        <vs-card style="width:100%;display:flex;flex-direction:column;">
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">Outbound Info</span>
          </div>
          <table style="width:100%">
            <tr>
              <td style="padding:4px 0;font-weight:bold;width:40%;">Outbound Reference</td>
              <td style="padding:4px 0;">{{ previewData.outbound_reference }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Status</td>
              <td style="padding:4px 0;">{{ previewData.status.name }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Client</td>
              <td style="padding:4px 0;">{{ previewData.client.client_code }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Origin</td>
              <td style="padding:4px 0;">{{ previewData.origin.name }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Destination</td>
              <td style="padding:4px 0;">{{ previewData.destination.name }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Order Type</td>
              <td style="padding:4px 0;">{{ previewData.order_type.order_type }}</td>
            </tr>
          </table>
        </vs-card>
      </div>

      <div class="vx-col md:w-1/2 w-full" style="display:flex;">
        <vs-card style="width:100%;display:flex;flex-direction:column;">
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">Records Akan Diupdate</span>
          </div>
          <table style="width:100%">
            <tr>
              <td style="padding:4px 0;font-weight:bold;width:50%;">Outbound</td>
              <td style="padding:4px 0;">1 record</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">AWB</td>
              <td style="padding:4px 0;">{{ previewData.awb ? '1 record' : '0 record' }}</td>
            </tr>
          </table>
        </vs-card>
      </div>
    </div>

    <div class="vx-row mt-6" v-if="showPreview">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label">New Outbound Reference</label>
        <vs-input
          class="w-full"
          v-model="newReference"
          placeholder="Enter new outbound reference"
          @keyup.enter="submitForm"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full" style="display:flex;align-items:flex-end;">
        <vs-button
          color="primary"
          class="btn mb-4 md:mb-0"
          @click="submitForm"
        >
          Process
        </vs-button>
      </div>
    </div>

    <vs-popup title="Konfirmasi Change Outbound Reference" :active.sync="showConfirmModal" v-if="previewData">
      <p style="margin-bottom:12px;">Apakah kamu yakin ingin memperbarui outbound reference?</p>
      <table style="width:100%;margin-bottom:16px;">
        <tr>
          <td style="padding:4px 0;font-weight:bold;width:40%;">Current Reference</td>
          <td style="padding:4px 0;">{{ oldReference }}</td>
        </tr>
        <tr>
          <td style="padding:4px 0;font-weight:bold;">New Reference</td>
          <td style="padding:4px 0;">{{ newReference }}</td>
        </tr>
      </table>
      <div style="display:flex;justify-content:flex-end;">
        <vs-button color="grey" class="btn mr-2" @click="showConfirmModal = false">Batal</vs-button>
        <vs-button color="primary" class="btn" @click="confirmUpdate">Ya, Update</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "ChangeOutboundReference",
  data() {
    return {
      oldReference: "",
      newReference: "",
      previewData: null,
      showPreview: false,
      showConfirmModal: false,
    };
  },
  methods: {
    searchPreview() {
      if (this.oldReference == "") {
        this.$vs.notify({ color: "danger", title: "Error", text: "Old Outbound Reference is required" });
        return false;
      }
      this.$emit("loading", true);
      this.showPreview = false;
      this.$http.post("support/outbound/preview", { outbound_reference: this.oldReference })
        .then((res) => {
          this.$emit("loading", false);
          this.previewData = res.data.data;
          this.showPreview = true;
          this.newReference = "";
        })
        .catch((error) => {
          this.$emit("loading", false);
          this.$emit("error", error);
        });
    },
    submitForm() {
      if (this.newReference == "") {
        this.$vs.notify({ color: "danger", title: "Error", text: "New Outbound Reference is required" });
        return false;
      }
      if (this.oldReference === this.newReference) {
        this.$vs.notify({ color: "danger", title: "Error", text: "Old and new reference are the same" });
        return false;
      }
      this.showConfirmModal = true;
    },
    confirmUpdate() {
      this.showConfirmModal = false;
      this.$emit("loading", true);
      this.$http.post("support/outbound/change-outbound-reference", {
        old_reference: this.oldReference,
        new_reference: this.newReference,
      })
        .then((res) => {
          this.$emit("loading", false);
          const data = res.data.data;
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: `Outbound reference "${data.old_reference}" berhasil diperbarui menjadi "${data.new_reference}".`,
          });
          this.oldReference = "";
          this.newReference = "";
          this.previewData = null;
          this.showPreview = false;
        })
        .catch((error) => {
          this.$emit("loading", false);
          this.$emit("error", error);
        });
    },
  },
};
</script>
